module.exports = __webpack_public_path__ + "img/plusfl_5x.65ffe4d1.png";